export default __webpack_public_path__ + "static/media/filosofia.4a0b65e3.png";